import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaClock, FaMapMarkerAlt, FaCalendarAlt, FaFutbol, FaUsers, FaRunning, FaTrophy } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Countdown from 'react-countdown';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const Schedule = () => {
  const [activeTab, setActiveTab] = useState('matches');
  const [matchFilter, setMatchFilter] = useState('all'); // 'all', 'live', 'upcoming', 'past'
  const [showModal, setShowModal] = useState(false);

  const coachingHours = [
    {
      ageGroup: "U9 - U11",
      hours: "3-5 hours per week",
      description: "3 coaching hours per week rising up to 5 hours for older Academy players",
      icon: <FaFutbol />,
      color: "blue"
    },
    {
      ageGroup: "U12 - U13",
      hours: "6-12 hours per week",
      description: "6 coaching hours per week rising up to 12 hours for older Academy players",
      icon: <FaRunning />,
      color: "green"
    },
    {
      ageGroup: "U15",
      hours: "6-12 hours per week",
      description: "6 coaching hours per week rising up to 12 hours for older Academy players",
      icon: <FaRunning />,
      color: "yellow"
    },
    {
      ageGroup: "U17",
      hours: "12-14 hours per week",
      description: "14 coaching hours per week reducing down to 12 hours for Academy players who have commitments to the Professional Squad during the Professional Development Phase",
      icon: <FaTrophy />,
      color: "red"
    }
  ];

  const trainingSchedule = [
    {
      day: "Monday",
      level: "Foundation Level",
      activities: ["Training"],
      icon: <FaFutbol />,
      color: "blue",
      sessions: [
        {
          category: "Technical Training",
          time: "09:00 - 11:00",
          type: "Ball Control & Passing",
          coach: "Coach John",
          location: "Main Field"
        },
        {
          category: "Tactical Training",
          time: "14:00 - 16:00",
          type: "Game Strategy",
          coach: "Coach Sarah",
          location: "Training Ground"
        }
      ]
    },
    {
      day: "Tuesday",
      level: "Foundation Level & Youth Development Level",
      activities: ["Training", "Match between the two sides", "Outside Friendly match"],
      icon: <FaRunning />,
      color: "green",
      sessions: [
        {
          category: "Match Day",
          time: "10:00 - 12:00",
          type: "Internal Match",
          coach: "Coach Mike",
          location: "Main Stadium"
        },
        {
          category: "Recovery",
          time: "15:00 - 16:00",
          type: "Light Training",
          coach: "Coach Emma",
          location: "Recovery Area"
        }
      ]
    },
    {
      day: "Wednesday",
      level: "Youth Development Level",
      activities: ["Training"],
      icon: <FaRunning />,
      color: "green",
      sessions: [
        {
          category: "Technical Training",
          time: "09:00 - 11:00",
          type: "Advanced Skills",
          coach: "Coach David",
          location: "Training Ground"
        },
        {
          category: "Physical Training",
          time: "14:00 - 16:00",
          type: "Strength & Conditioning",
          coach: "Coach Lisa",
          location: "Gym"
        }
      ]
    },
    {
      day: "Thursday",
      level: "Youth Development Level & Professional Level",
      activities: ["Training", "Match between the two sides", "Outside Friendly match"],
      icon: <FaRunning />,
      color: "yellow",
      sessions: [
        {
          category: "Match Day",
          time: "10:00 - 12:00",
          type: "League Match",
          coach: "Coach Robert",
          location: "Main Stadium"
        },
        {
          category: "Recovery",
          time: "15:00 - 16:00",
          type: "Recovery Session",
          coach: "Coach Mark",
          location: "Recovery Area"
        }
      ]
    },
    {
      day: "Friday",
      level: "Professional Development Level",
      activities: ["Training"],
      icon: <FaTrophy />,
      color: "red",
      sessions: [
        {
          category: "Professional Training",
          time: "09:00 - 11:00",
          type: "Advanced Tactics",
          coach: "Coach James",
          location: "Training Ground"
        },
        {
          category: "Match Preparation",
          time: "14:00 - 16:00",
          type: "Team Training",
          coach: "Coach Michael",
          location: "Main Field"
        }
      ]
    },
    {
      day: "Saturday",
      level: "Professional Development Level",
      activities: ["Training", "Match between the two sides", "League Matches"],
      icon: <FaTrophy />,
      color: "red",
      sessions: [
        {
          category: "Match Day",
          time: "14:00 - 16:00",
          type: "League Match",
          coach: "Coach Thomas",
          location: "Main Stadium"
        },
        {
          category: "Post-Match",
          time: "16:30 - 17:30",
          type: "Recovery",
          coach: "Coach Daniel",
          location: "Recovery Area"
        }
      ]
    },
    {
      day: "Sunday",
      level: "Foundation Level",
      activities: ["Friendly Match"],
      icon: <FaFutbol />,
      color: "blue",
      sessions: [
        {
          category: "Match Day",
          time: "10:00 - 12:00",
          type: "Friendly Match",
          coach: "Coach Andrew",
          location: "Training Ground"
        },
        {
          category: "Recovery",
          time: "13:00 - 14:00",
          type: "Light Recovery",
          coach: "Coach Sophie",
          location: "Recovery Area"
        }
      ]
    }
  ];

  const liveMatches = [
    {
      id: 1,
      competition: "Youth Premier League",
      home: {
        name: "Kempshot U13",
        logo: "/img/teams/elite-u13.png", // Add your logo paths
        score: 2
      },
      away: {
        name: "City Stars U13",
        logo: "/img/teams/city-stars.png",
        score: 1
      },
      time: "65'",
      venue: "Elite Academy Ground",
      status: "LIVE",
      details: {
        stats: {
          possession: { home: 58, away: 42 },
          shots: { home: 12, away: 8 },
          shotsOnTarget: { home: 5, away: 3 },
          corners: { home: 6, away: 4 },
          fouls: { home: 8, away: 10 }
        },
        events: [
          { time: "65'", type: "goal", team: "home", player: "John Smith", assist: "Mike Johnson" },
          { time: "45'", type: "yellow", team: "away", player: "Tom Wilson" },
          { time: "32'", type: "goal", team: "away", player: "Alex Brown" },
          { time: "23'", type: "goal", team: "home", player: "John Smith" }
        ],
        lineups: {
          home: {
            starting: ["J. Smith", "M. Johnson", "A. Williams", "R. Brown", "C. Davis"],
            subs: ["T. Wilson", "S. Miller", "D. Anderson"]
          },
          away: {
            starting: ["A. Brown", "L. Taylor", "E. Martinez", "K. White", "D. Lee"],
            subs: ["R. Garcia", "J. Moore", "P. Jackson"]
          }
        }
      }
    }
  ];

  const upcomingMatches = [
    {
      id: 1,
      date: "2024-04-15 14:00:00",
      competition: "Youth Premier League",
      home: {
        name: "Kempshot U15",
        logo: "/img/teams/elite-u15.png"
      },
      away: {
        name: "United Youth",
        logo: "/img/teams/united.png"
      },
      venue: "Elite Academy Ground",
      type: "League Match",
      round: "Quarter Finals",
      details: {
        headToHead: {
          total: 8,
          wins: 5,
          draws: 2,
          losses: 1,
          lastMatches: [
            { result: "W", score: "3-1" },
            { result: "D", score: "2-2" },
            { result: "W", score: "1-0" }
          ]
        },
        predictedLineups: {
          // ... similar to live match lineups
        },
        venue: {
          name: "Elite Academy Ground",
          capacity: "5,000",
          surface: "Natural Grass",
          location: "Accra, Ghana"
        }
      }
    }
  ];

  const pastMatches = [
    {
      id: 1,
      date: "2024-04-01",
      competition: "Regional Cup",
      home: {
        name: "Kempshot U13",
        logo: "/img/teams/elite-u13.png",
        score: 3
      },
      away: {
        name: "City Academy",
        logo: "/img/teams/city.png",
        score: 1
      },
      venue: "Central Stadium",
      result: "WIN",
      details: {
        events: [
          { time: "78'", type: "goal", team: "home", player: "John Smith", assist: "Mike Johnson" },
          { time: "65'", type: "goal", team: "home", player: "Mike Johnson" },
          { time: "45'", type: "yellow", team: "away", player: "Tom Wilson" },
          { time: "32'", type: "goal", team: "away", player: "Alex Brown", assist: "James Wilson" },
          { time: "23'", type: "goal", team: "home", player: "John Smith", assist: "David Lee" }
        ]
      }
    }
  ];

  const specialEvents = [
    {
      title: "Talent Identification Day",
      date: "2024-04-20",
      time: "09:00 - 17:00",
      description: "Open trials for new academy prospects",
      icon: <FaUsers />,
      color: "purple"
    },
    {
      title: "Skills Workshop",
      date: "2024-04-22",
      time: "14:00 - 16:00",
      description: "Special training session with guest coach",
      icon: <FaRunning />,
      color: "orange"
    }
  ];

  const ComingSoonModal = () => (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          onClick={() => setShowModal(false)}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaClock className="text-2xl text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Coming Soon!</h3>
              <p className="text-gray-600 mb-6">This feature is currently under development. Stay tuned for updates!</p>
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <div className="min-h-screen relative">
      <ComingSoonModal />
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="relative py-20">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Academy Schedule
                </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Comprehensive training and match schedule designed for optimal player development
                </p>
                <div className="flex flex-wrap gap-4">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowModal(true)}
                    className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    View Schedule
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowModal(true)}
                    className="bg-white/10 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/20 transition-colors duration-200"
                  >
                    Download Calendar
                  </motion.button>
                </div>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <img
                    src={require("../../assets/img/pictures/nnn.jpg")}
                    alt="Academy Training"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                  />
                  <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg">
                    <p className="text-sm font-semibold">Structured Development</p>
                    <p className="text-xs opacity-80">Training & Matches</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Coaching Hours Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Coaching Hours</h2>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Structured coaching hours designed to maximize player development at each age group
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {coachingHours.map((program, index) => (
                <motion.div
                  key={program.ageGroup}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className={`text-3xl text-${program.color}-400`}>
                      {program.icon}
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white">{program.ageGroup}</h3>
                      <p className="text-blue-200">{program.hours}</p>
                    </div>
                  </div>
                  <p className="text-blue-100">{program.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Training Schedule Section */}
        <section className="py-16 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Training & Match Schedule</h2>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Weekly schedule of training sessions and matches for all academy levels
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {trainingSchedule.map((day, index) => (
                <motion.div
                  key={day.day}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl overflow-hidden"
                >
                  <div className="bg-white/10 px-6 py-4">
                    <div className="flex items-center gap-4">
                      <div className={`text-${day.color}-400 text-2xl`}>
                        {day.icon}
                      </div>
                      <h3 className="text-xl font-semibold text-white">{day.day}</h3>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="mb-4">
                      <h4 className="text-white font-semibold mb-2">{day.level}</h4>
                      <div className="flex flex-wrap gap-2">
                        {day.activities.map((activity, i) => (
                          <span
                            key={i}
                            className="bg-white/5 text-blue-100 px-3 py-1 rounded-full text-sm"
                          >
                            {activity}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Schedule Navigation */}
        <section className="py-8">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center gap-4">
              {['matches', 'events'].map((tab) => (
                <motion.button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${
                    activeTab === tab 
                      ? 'bg-blue-600 text-white' 
                      : 'bg-white/10 text-white/80 hover:bg-white/20'
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </motion.button>
              ))}
            </div>
          </div>
        </section>

        {/* Schedule Content */}
        <section className="py-8 pb-16">
          <div className="container mx-auto px-4 overflow-x-hidden">
            {/* Matches Schedule */}
            {activeTab === 'matches' && (
              <div className="space-y-8">
                {/* Coming Soon Feature */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaClock />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Matches Section Coming Soon</h3>
                  <p className="text-blue-100">We're working on bringing you the latest match information. Stay tuned!</p>
                </motion.div>
              </div>
            )}

            {/* Special Events */}
            {activeTab === 'events' && (
              <div className="space-y-8">
                {/* Coming Soon Feature */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaClock />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Events Section Coming Soon</h3>
                  <p className="text-blue-100">We're working on bringing you the latest events and activities. Stay tuned!</p>
                </motion.div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Schedule; 